<ca-card>
  <div ca-card-title class="titulo-seccion-recomendador">
    {{ 'SALUD.RECOMENDADOR.SUBTITULO_TIPO_CLIENTE' | translate }}
  </div>
  <div ca-card-content class="opciones-container">
    <app-opcion-recomendador
      *ngFor="let opcion of opcionesTiposCliente"
      [opcion]="opcion"
      [seleccionada]="opcion === tipoClienteSeleccionado"
      (seleccionarOpcion)="onSeleccionarTipoCliente($event)">
    </app-opcion-recomendador>
  </div>
</ca-card>

<!-- Niveles dinámicos -->
<ng-container *ngFor="let opciones of niveles; let i = index">
  <ca-card *ngIf="opciones?.length > 0">
    <div ca-card-title class="titulo-seccion-recomendador">
      <ng-container *ngIf="selecciones[i-1]">
        {{ ('SALUD.RECOMENDADOR.LABEL_OPCION.' + selecciones[i-1].codCategoria + '_' + selecciones[i-1].titulo + '_TITULO') | translate }}
      </ng-container>
      <ng-container *ngIf="!selecciones[i-1]">
        {{ 'SALUD.RECOMENDADOR.LABEL_OPCION.SELECCION_COBERTURA_SECCION' | translate }}
      </ng-container>
    </div>

    <div ca-card-content class="opciones-container">
      <app-opcion-recomendador
        *ngFor="let opcion of opciones"
        [opcion]="opcion"
        [deshabilitada]="navegacionDeshabilitada"
        [seleccionada]="opcion === selecciones[i]"
        (seleccionarOpcion)="onSeleccionarNivel($event, i)">
      </app-opcion-recomendador>
    </div>
  </ca-card>
</ng-container>

<!-- Resultados / colectivas -->
<ca-card *ngIf="(colectivasAgrupacion?.colectivas.length > 0 || colectivasAgrupacion?.colectivasAlternativas.length > 0) && selecciones.length">
  <div ca-card-title class="titulo-seccion-recomendador">
    <ng-container *ngIf="selecciones.length">
      <!-- construir breadcrumb simple a partir de selecciones -->
      <span *ngFor="let s of selecciones; let idx = index">
        <ng-container *ngIf="s">{{ ('SALUD.RECOMENDADOR.LABEL_OPCION.' + s.codCategoria + '_' + s.titulo + '_TITULO') | translate }}<span *ngIf="idx < selecciones.length - 1"> > </span></ng-container>
      </span>
    </ng-container>
  </div>
</ca-card>